import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import { Result } from 'antd'
import { TabConfig } from '../../types'

interface PagesProps {
	tabs: TabConfig[]
}

export default function Pages({ tabs }: PagesProps) {
	const match = useRouteMatch()

	return (
		<Switch>
			{tabs.map(tab => {
				return <Route key={tab.id} path={`${match.path.replace('/:tab', `/${tab.id}`)}`} render={tab.render} />
			})}
			<NotFound />
		</Switch>
	)
}

const NotFound = (): JSX.Element => <Result status='404' title='This page does not exist' />
